import type { UnionTypeLibelle } from "@/features/domaine/types/techniques"

export const ModalitePedagogique = [
  'Presentielle',
  'Mixte',
  'Distance',
] as const

export type ModalitePedagogique = typeof ModalitePedagogique[number]

export const ModalitePedagogiqueLibelle: UnionTypeLibelle<ModalitePedagogique> = {
  Presentielle: 'Présentielle',
  Mixte: 'Mixte',
  Distance: 'A Distance',
} as const
